module.exports = __webpack_public_path__ + "img/156.df9776a2.jpg";